<script>
import { defineComponent } from "vue";
import { hexToRgba } from "@/helpers/color";

export default defineComponent({
  name: "AppTag",
  props: {
    tag: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: "large", // mini, small, large
    },
    textTransform: {
      type: String,
      default: () => "uppercase",
    },
  },
  methods: {
    getBgColor(color, opacity) {
      return hexToRgba(color, opacity);
    },
  },
});
</script>

<template>
  <div
    class="tag"
    :class="[size, textTransform]"
    :style="[
      (tag.color && {
        color: tag.color,
        backgroundColor: getBgColor(tag.color),
        borderColor: getBgColor(tag.color, 0.3),
      }) ||
        '',
    ]"
  >
    {{ tag.value || tag.title }}
  </div>
</template>

<style scoped lang="scss">
.tag {
  font-size: 10px;
  @apply h-7 bg-gray-100 border border-solid border-gray-100 text-gray-600 rounded-sm px-2 font-medium flex items-center pt-0.5;

  &.small {
    @apply h-5 px-1;
    font-size: 9px;
    img {
      @apply w-3 h-3;
    }
  }

  &.mini {
    @apply h-4 px-1;
    font-size: 8px;
    img {
      @apply w-3 h-3;
    }
  }
}
</style>
